import { render } from "./BillingFinalizingOverlay.vue?vue&type=template&id=189a1960&scoped=true"
import script from "./BillingFinalizingOverlay.vue?vue&type=script&lang=js"
export * from "./BillingFinalizingOverlay.vue?vue&type=script&lang=js"

import "./BillingFinalizingOverlay.vue?vue&type=style&index=0&id=189a1960&scoped=true&lang=css"

import exportComponent from "C:\\Users\\darca\\dev\\spanish-ai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-189a1960"]])

export default __exports__